export class FormObserver {
  constructor() {
    // Создаем экземпляр MutationObserver
    this.observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Если добавлен узел является формой
              if (node.tagName === 'FORM') {
                this.preventFormSubmit(node);
              }

              // Если узел содержит вложенные формы
              if (typeof node.querySelectorAll !== 'undefined') {
                node.querySelectorAll('form').forEach((form) => {
                  this.preventFormSubmit(form);
                });
              }
            }
          });
        }
      });
    });

    // Начинаем наблюдение за документом
    this.observeDocument();
  }

  observeDocument() {
    this.observer.observe(document.body, {
      childList: true,
      subtree: true, // Включаем наблюдение за вложенными элементами
    });

    // Обрабатываем уже существующие формы
    document.querySelectorAll('form').forEach((form) => {
      this.preventFormSubmit(form);
    });
  }

  preventFormSubmit(form) {
    // Добавляем обработчик предотвращения отправки формы
    form.addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    });
  }
}
